import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import api from "../api";
import Seo from "../components/Seo";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const [state, setState] = useState("working");

  useEffect(() => {
    const token = params.get("token");
    if (!token) return setState("invalid");
    api.get("/auth/verify-email", { params: { token } })
      .then(() => setState("ok"))
      .catch(() => setState("invalid"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="max-w-md mx-auto px-4 py-24 text-center" data-testid="verify-email-page">
      <Seo title="Verify email | CourierRadar" noindex />
      {state === "working" && <p className="text-sm text-zinc-500">Verifying your email…</p>}
      {state === "ok" && (
        <>
          <h1 className="text-2xl font-extrabold tracking-tight">Email verified</h1>
          <p className="text-sm text-zinc-500 mt-3">Your email is confirmed. Our team will now review your account — you'll get an email when you're approved.</p>
          <Link to="/" data-testid="verify-home-link" className="inline-block mt-6 bg-black text-white px-6 py-3 rounded-lg text-sm font-medium">Continue</Link>
        </>
      )}
      {state === "invalid" && (
        <>
          <h1 className="text-2xl font-extrabold tracking-tight">Link expired</h1>
          <p className="text-sm text-zinc-500 mt-3">This verification link is invalid or already used. Sign in and request a new one from your account page.</p>
          <Link to="/auth" className="inline-block mt-6 bg-black text-white px-6 py-3 rounded-lg text-sm font-medium">Sign in</Link>
        </>
      )}
    </div>
  );
}
